import * as e from "react";
const l = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.859 5.231C17.583 4.582 16.699 4 16 4h-6v7.802l2.838 6.609c.091.213.145.44.159.672A1.04 1.04 0 0013 19v-4a2 2 0 012-2h4a1 1 0 001-1v-1.792L17.859 5.23zM22 10c0-.134-.027-.267-.08-.39L19.7 4.45C19.11 3.06 17.5 2 16 2h-6a2.006 2.006 0 00-2 2v8.015a1 1 0 00.08.385L11 19.2V21a1 1 0 001 1 3 3 0 003-3v-4h4a3 3 0 003-3v-2zM6 12.011V3a1 1 0 00-1-1H3a1 1 0 00-1 1v9a1 1 0 001 1h2a1 1 0 001-.989z",
      fill: "#2d6ded"
    }
  )
), t = l;
export {
  t as default
};
